import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "primaryInput",
    "secondaryInput",
    "accentInput",
    "primaryButton",
    "secondaryButton",
    "accentButton",
    "primaryText",
    "secondaryText",
    "accentText",
  ];

  connect() {
    this.updateColors();
  }

  updateColors() {
    const primary = this.primaryInputTarget.value;
    const secondary = this.secondaryInputTarget.value;
    const accent = this.accentInputTarget.value;

    // Update buttons
    this.primaryButtonTarget.style.backgroundColor = primary;
    this.secondaryButtonTarget.style.backgroundColor = secondary;
    this.accentButtonTarget.style.backgroundColor = accent;

    // Update text
    this.primaryTextTarget.style.color = primary;
    this.secondaryTextTarget.style.color = secondary;
    this.accentTextTarget.style.color = accent;
  }
}
